@import "../../shared.css";

:host {
	position: relative;
	display: flex;
	background-color: rgb(var(--smoothly-input-background));
}

:host [slot=start] {
	align-self: center;
}

:host .label {
	left: var(--input-padding-side);
}

:host .smoothly-date-range-separator {
	white-space: pre;
}

:host .smoothly-date-range-placeholder {
	margin-inline: var(--input-padding-side);
	display: none;
}

:host:not([always-show-guide]):not(:focus-within):not(.has-text) {
	& .smoothly-date-range-placeholder {
		display: block;
		opacity: 0.5;
	}

	& smoothly-date-text,
	& .smoothly-date-range-separator {
		visibility: hidden;
	}
}

:host smoothly-date-text.start-date-text {
	margin-inline: var(--input-padding-side) 0;
}

:host smoothly-date-text.end-date-text {
	margin-inline: 0 var(--input-padding-side);
}

:host[show-label] .smoothly-date-range-placeholder,
:host[show-label] smoothly-date-text,
:host[show-label] .smoothly-date-range-separator {
	margin-block: var(--input-value-padding-top) var(--input-value-padding-bottom);
}

:host:not([show-label]) .smoothly-date-range-placeholder,
:host:not([show-label]) smoothly-date-text,
:host:not([show-label]) .smoothly-date-range-separator {
	margin-block: auto;
}

:host:not([readonly]) {
	cursor: pointer;
}

:host[disabled] {
	cursor: not-allowed;
}

:host > smoothly-calendar {
	position: absolute;
	z-index: 20;
	top: 4rem;
	background-color: rgb(var(--smoothly-input-background));
	max-width: 22rem;
	min-width: 18rem;
}

:host > smoothly-calendar::before {
	content: "";
	position: absolute;
	top: -0.55rem;
	left: 3rem;
	z-index: 9;
	transform: rotate(45deg);
	width: 1rem;
	height: 1rem;
	background-color: rgb(var(--smoothly-input-background));
	border-top: 1px solid rgb(var(--smoothly-input-border));
	border-left: 1px solid rgb(var(--smoothly-input-border));
}

:host > .smoothly-date-range-input-part {
	display: flex;
	width: 100%;
	background-color: var(--smoothly-input-background);
	border-radius: 0.25rem;
	cursor: pointer;
}

:host > span.smoothly-icons {
	display: flex;
	flex-direction: row;
	align-items: center;
}

:host > .smoothly-icons > .smoothly-invalid {
	display: none;
	padding: 0.5rem;
}

:host[invalid] > .smoothly-icons > .smoothly-invalid {
	display: flex;
}
